import { P as a, r as x, e as m, R as y, w as P, H as l, p as v, m as w, a as C, d as u, E as _, b as T, t as g, c as A } from "./surface-71c0d1c6.js";
var f = Math.PI / 2, O = function(i) {
  function t(n, o) {
    n === void 0 && (n = new a()), o === void 0 && (o = 0), i.call(this), this.setCenter(n), this.setRadius(o);
  }
  return i && (t.__proto__ = i), t.prototype = Object.create(i && i.prototype), t.prototype.constructor = t, t.prototype.setCenter = function(o) {
    return this._observerField("center", a.create(o)), this.geometryChange(), this;
  }, t.prototype.getCenter = function() {
    return this.center;
  }, t.prototype.equals = function(o) {
    return o && o.center.equals(this.center) && o.radius === this.radius;
  }, t.prototype.clone = function() {
    return new t(this.center.clone(), this.radius);
  }, t.prototype.pointAt = function(o) {
    return this._pointAt(x(o));
  }, t.prototype.bbox = function(o) {
    for (var e = this, r = m(this.center, this.radius, this.radius, o), s = a.maxPoint(), c = a.minPoint(), p = 0; p < 4; p++) {
      var b = e._pointAt(r.x + p * f).transformCopy(o), d = e._pointAt(r.y + p * f).transformCopy(o), h = new a(b.x, d.y);
      s = a.min(s, h), c = a.max(c, h);
    }
    return y.fromPoints(s, c);
  }, t.prototype._pointAt = function(o) {
    var e = this, r = e.center, s = e.radius;
    return new a(
      r.x + s * Math.cos(o),
      r.y + s * Math.sin(o)
    );
  }, t.prototype.containsPoint = function(o) {
    var e = this, r = e.center, s = e.radius, c = Math.pow(o.x - r.x, 2) + Math.pow(o.y - r.y, 2) <= Math.pow(s, 2);
    return c;
  }, t.prototype._isOnPath = function(o, e) {
    var r = this, s = r.center, c = r.radius, p = s.distanceTo(o);
    return c - e <= p && p <= c + e;
  }, t;
}(P(l, ["radius"]));
const B = O;
var M = "#000", E = function(i) {
  function t(o, e) {
    o === void 0 && (o = new B()), e === void 0 && (e = {}), i.call(this, e), this.geometry(o), u(this.options.stroke) || this.stroke(M);
  }
  i && (t.__proto__ = i), t.prototype = Object.create(i && i.prototype), t.prototype.constructor = t;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Circle";
  }, t.prototype.rawBBox = function() {
    return this._geometry.bbox();
  }, t.prototype._bbox = function(e) {
    return this._geometry.bbox(e);
  }, t.prototype._containsPoint = function(e) {
    return this.geometry().containsPoint(e);
  }, t.prototype._isOnPath = function(e) {
    return this.geometry()._isOnPath(e, this.options.stroke.width / 2);
  }, Object.defineProperties(t.prototype, n), t;
}(v(w(C(_))));
const $ = E;
var F = "12px sans-serif", j = "#000", D = function(i) {
  function t(o, e, r) {
    e === void 0 && (e = new a()), r === void 0 && (r = {}), i.call(this, r), this.content(o), this.position(e), this.options.font || (this.options.font = F), u(this.options.fill) || this.fill(j);
  }
  i && (t.__proto__ = i), t.prototype = Object.create(i && i.prototype), t.prototype.constructor = t;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Text";
  }, t.prototype.content = function(e) {
    return u(e) ? (this.options.set("content", e), this) : this.options.get("content");
  }, t.prototype.measure = function() {
    var e = T(this.content(), {
      font: this.options.get("font")
    });
    return e;
  }, t.prototype.rect = function() {
    var e = this.measure(), r = this.position().clone();
    return new y(r, [e.width, e.height]);
  }, t.prototype.bbox = function(e) {
    var r = g(this.currentTransform(e));
    return this.rect().bbox(r);
  }, t.prototype.rawBBox = function() {
    return this.rect().bbox();
  }, t.prototype._containsPoint = function(e) {
    return this.rect().containsPoint(e);
  }, Object.defineProperties(t.prototype, n), t;
}(v(A(_, ["position"])));
const I = D;
export {
  $ as C,
  B as G,
  I as T
};
